var Mapcofig = /** @class */ (function () {
    // tslint:disable-next-line:no-empty
    function Mapcofig() {
    }
    Mapcofig.jsapi = 'http://10.81.71.243:23456/zwwthreed74/arcgisapi';
    Mapcofig.jsapiversion4X = '4.0';
    Mapcofig.tokenserver = {
        tokenType: 'free',
        token_front: {
            url: '',
            user: 'none',
            password: 'none'
        },
        token_black: {
            url: '',
            tokenconfigname: ''
        }
    };
    Mapcofig.proxyURL = "http://10.81.71.243:23456/zwwthreed74/proxy.jsp";
    Mapcofig.proxyConifg = {
        useProxy: true,
        url: Mapcofig.proxyURL + '?',
        httpsDomains: [{
                proxyUrl: Mapcofig.proxyURL,
                domainName: '168.168.112.84:6080'
            }, {
                proxyUrl: Mapcofig.proxyURL,
                domainName: '168.168.112.76:6080'
            }, {
                proxyUrl: Mapcofig.proxyURL,
                domainName: '168.168.112.74:6080'
            }, {
                proxyUrl: Mapcofig.proxyURL,
                domainName: '168.168.112.79'
            }]
    };
    Mapcofig.fonts = {
        url: 'http://10.81.71.243:23456/zwwthreed74/arcgisapi/4.15/fonts'
    };
    Mapcofig.gisService = {};
    return Mapcofig;
}());
export default Mapcofig;
